var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNewRequest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 135,
    viewBox: "0 0 132 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_406)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.2896,
    y: 21.5264,
    width: 81.6579,
    height: 85.4737,
    rx: 7.63158,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 84,
    transform: "translate(25 22)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1371 25.481H29.252V28.3566H32.1371V25.481Z",
    fill: "#1B5984"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9074 25.481H35.0222V28.3566H37.9074V25.481Z",
    fill: "#1B5984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6777 25.481H40.7925V28.3566H43.6777V25.481Z",
    fill: "#1B5984"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.137 47.0487V55.6757C32.137 56.4665 32.7861 57.1135 33.5796 57.1135H76.8573V54.2379H35.0221V48.4865H98.4962V54.2379H94.1684V57.1135H99.9388C100.732 57.1135 101.381 56.4665 101.381 55.6757V47.0487C101.381 46.2579 100.732 45.6108 99.9388 45.6108H33.5796C32.7861 45.6108 32.137 46.2579 32.137 47.0487Z",
    fill: "#1B5984"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1203 39.8594H32.137V42.7351H45.1203V39.8594Z",
    fill: "#1B5984"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3333 61.4272H32.137V64.3029H52.3333V61.4272Z",
    fill: "#1B5984"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9388 67.1784H95.611V70.054H98.4962V75.8054H90.9947L92.7259 75.1763C93.4652 74.9067 93.8619 74.08 93.5914 73.3251L90.2554 64.2488L94.3307 63.8174C95.1242 63.7275 95.7012 63.0266 95.611 62.2358C95.575 61.8404 95.3586 61.463 95.034 61.2293L82.4293 52.0631C81.7802 51.5958 80.8786 51.7396 80.4097 52.3686C80.3015 52.5304 80.2114 52.6921 80.1753 52.8719L76.5328 67.9871C76.3524 68.76 76.8213 69.5328 77.5967 69.7125C77.9934 69.8024 78.4081 69.7305 78.7507 69.4969L82.1408 67.1963L85.2965 75.7694H35.0221V70.0181H73.9721V67.1424H33.5796C32.7861 67.1424 32.137 67.7894 32.137 68.5802V77.2073C32.137 77.9981 32.7861 78.6451 33.5796 78.6451H99.9388C100.732 78.6451 101.381 77.9981 101.381 77.2073V68.5802C101.381 67.8254 100.732 67.1784 99.9388 67.1784ZM83.2769 63.6377C82.8621 63.4939 82.3933 63.5658 82.0326 63.8174L80.1933 65.0576L82.4654 55.6577L90.3095 61.3731L88.1096 61.6067C87.3161 61.6966 86.7391 62.3975 86.8293 63.1884C86.8473 63.3142 86.8653 63.422 86.9014 63.5298L90.3816 72.9836L87.6768 73.9721L84.1965 64.5184C84.0342 64.105 83.7096 63.7815 83.2769 63.6377Z",
    fill: "#1B5984"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3333 82.9946H32.137V85.8703H52.3333V82.9946Z",
    fill: "#1B5984"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9388 88.7461H33.5796C32.7861 88.7461 32.137 89.3931 32.137 90.1839V98.811C32.137 99.6018 32.7861 100.249 33.5796 100.249H99.9388C100.732 100.249 101.381 99.6018 101.381 98.811V90.1839C101.381 89.3931 100.732 88.7461 99.9388 88.7461ZM98.4962 97.3731H35.0221V91.6218H98.4962V97.3731Z",
    fill: "#1B5984"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9456 35.6061C59.5642 35.6018 59.1858 35.6745 58.833 35.8199C58.4801 35.9653 58.1601 36.1805 57.8918 36.4526C57.6236 36.7247 57.4127 37.0481 57.2716 37.4037C57.1306 37.7593 57.0623 38.1397 57.0708 38.5223C57.1085 39.3049 57.448 40.042 58.0176 40.5779C58.5872 41.1139 59.3421 41.4065 60.1229 41.3941C61.6869 41.3941 62.4405 40.9049 63.7575 41.1717C64.4613 41.3046 65.1096 41.6453 65.6192 42.1501C65.67 42.2067 65.7387 42.2439 65.8137 42.2555C65.8887 42.267 65.9654 42.2523 66.0308 42.2136C66.1448 42.1374 66.2271 41.9976 66.1448 41.6545C65.9196 40.7822 65.5516 39.9534 65.0556 39.2021C64.0868 37.7091 62.1365 35.6061 59.9456 35.6061Z",
    fill: "#3C8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3064 35.6061C73.6881 35.6018 74.0668 35.6745 74.42 35.8198C74.7731 35.9651 75.0936 36.1802 75.3623 36.4522C75.6311 36.7242 75.8426 37.0476 75.9844 37.4032C76.1261 37.7588 76.1952 38.1394 76.1876 38.5223C76.1498 39.306 75.8094 40.0441 75.2385 40.5802C74.6675 41.1163 73.911 41.4082 73.1291 41.3941C71.5714 41.3941 70.8179 40.9048 69.5008 41.1717C68.7958 41.3012 68.1467 41.6424 67.6391 42.1501C67.5873 42.2072 67.5175 42.2446 67.4414 42.2562C67.3653 42.2678 67.2876 42.2527 67.2212 42.2136C67.1072 42.1374 67.0313 41.9976 67.1072 41.6545C67.3347 40.7819 67.7048 39.9532 68.2027 39.2021C69.1652 37.7091 71.1282 35.6061 73.3064 35.6061",
    fill: "#3C8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4688 30.6759C68.1169 30.6629 67.7669 30.7319 67.4461 30.8774C67.1253 31.0229 66.8425 31.241 66.6198 31.5145C66.3983 31.2411 66.1166 31.023 65.7969 30.8775C65.4771 30.7319 65.128 30.6629 64.7771 30.6759C64.4057 30.6775 64.0384 30.7529 63.6962 30.8978C63.3541 31.0427 63.044 31.2542 62.7837 31.52C62.5235 31.7858 62.3184 32.1008 62.1801 32.4466C62.0419 32.7924 61.9733 33.1623 61.9783 33.5349C61.9867 34.1462 62.186 34.7395 62.5482 35.2312C62.9332 35.7518 63.3845 36.2196 63.8906 36.6226C64.9193 37.4606 65.7406 38.5262 66.2905 39.7358C66.3176 39.8057 66.3631 39.8668 66.4223 39.9127C66.4814 39.9586 66.5518 39.9875 66.6261 39.9962C66.7012 39.9879 66.7727 39.9593 66.8329 39.9134C66.8932 39.8676 66.9398 39.8062 66.968 39.7358C67.5159 38.5267 68.3351 37.4612 69.3616 36.6226C69.8694 36.2194 70.3227 35.7517 70.7103 35.2312C71.0676 34.7374 71.2644 34.145 71.2739 33.5349C71.2798 33.1615 71.2116 32.7908 71.0732 32.4441C70.9349 32.0975 70.7292 31.782 70.4681 31.5159C70.2071 31.2498 69.8958 31.0385 69.5526 30.8943C69.2093 30.7501 68.8409 30.6758 68.4688 30.6759M70.0138 34.7166C69.0007 36.108 67.6266 36.5527 66.6198 38.7319C65.6193 36.5527 64.2452 36.108 63.2321 34.7166C62.9772 34.3826 62.8372 33.9746 62.8331 33.5539C62.8314 33.0158 63.0424 32.499 63.4199 32.1167C63.7973 31.7344 64.3104 31.5179 64.8468 31.5145C65.2352 31.5265 65.6114 31.6536 65.9281 31.8797C66.2447 32.1058 66.4876 32.4208 66.6261 32.7852C66.766 32.4218 67.0093 32.1076 67.3256 31.8817C67.6419 31.6558 68.0174 31.5281 68.4054 31.5145C68.9417 31.5179 69.4548 31.7344 69.8323 32.1167C70.2097 32.499 70.4207 33.0158 70.4191 33.5539C70.4177 33.9751 70.2775 34.3839 70.0201 34.7166",
    fill: "#3C8200"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.65 20H27.35C24.9575 20 23 21.9575 23 24.35V102.65C23 105.043 24.9575 107 27.35 107H105.65C108.043 107 110 105.043 110 102.65V24.35C110 21.9575 108.043 20 105.65 20ZM107.1 25.8H46.2V28.7H107.1V102.65C107.1 103.448 106.448 104.1 105.65 104.1H27.35C26.5525 104.1 25.9 103.448 25.9 102.65V24.35C25.9 23.5525 26.5525 22.9 27.35 22.9H105.65C106.448 22.9 107.1 23.5525 107.1 24.35V25.8Z",
    fill: "#1B5984"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_406",
    x: 0.868498,
    y: 0.157946,
    width: 130.5,
    height: 134.316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.05263
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2105
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.34902 0 0 0 0 0.517647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3781,
    height: 12.0714,
    fill: "white",
    transform: "translate(57.0701 30.6743)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNewRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_new_request.fb23056986242f1183afa6762fedd555.svg";